// extracted by mini-css-extract-plugin
module.exports = {"sub-header":"styles-module__sub-header___3xfwd"};